import dynamic from 'next/dynamic'
import { run } from '@/utils/run'
import { cn } from '@/utils/styles/cn'

const CustomVideoPlayer = dynamic(() => import('./custom-video-player'), { ssr: false })

interface IVideoPlayerProps {
    index?: number
    isDuplicate?: boolean
    url: string
    thumbnailUrl?: string
    makeRef: (index: number) => (el: HTMLDivElement) => void
    videoWidth: number
    videoHeight: number
    videoContainerHeight: number
    videoContainerWidth: number
    autoPlay?: boolean
    forceMobileView?: boolean
}

export const RestaurantDetailVideo = ({
    index,
    isDuplicate,
    url,
    thumbnailUrl,
    makeRef,
    videoWidth,
    videoHeight,
    videoContainerHeight,
    videoContainerWidth,
    autoPlay = false,
    forceMobileView = false,
}: IVideoPlayerProps) => {
    const actualIndex = index

    return (
        <div
            ref={typeof actualIndex === 'number' ? makeRef(actualIndex) : undefined}
            className={cn(
                'restaurant-detail-images-image-container--mobile bg-white md:bg-gray-100',
                !forceMobileView && 'md:restaurant-detail-images-image-container--desktop',
                isDuplicate && 'hidden md:block'
            )}
        >
            {run(() => {
                if (videoWidth === 0 || videoHeight === 0) return null

                return (
                    <CustomVideoPlayer
                        url={url}
                        thumbnailUrl={thumbnailUrl}
                        data-testid={url}
                        videoContainerHeight={videoContainerHeight}
                        videoContainerWidth={videoContainerWidth}
                        videoWidth={videoWidth}
                        videoHeight={videoHeight}
                        autoPlay={autoPlay}
                    />
                )
            })}
        </div>
    )
}
